import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetProviderList } from '../../store/thunk/setGetProviderList';
import Title from '../../components/title';
import RTP from '../../components/rtp';
import ProviderItem from '../../components/providerItem';
import {useStyles} from './helper';
import moment from 'moment';

const Report = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const utc = moment.utc().valueOf();
    React.useEffect(() => {
        dispatch(setGetProviderList({
            date_from: 0,
            date_to: utc
        }));
    }, [])

    const list = useSelector(state => state.providerMobile.list);

    const getRtpGroup = (value) => {
        let countSlot = 0;
        let countLive = 0;
        const live = ['Betgames', 'Ezugi'];

        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            
            if (live.includes(item.provider)) {
                countLive += item.sum_win/item.sum*100;
            } else {
                countSlot += item.sum_win/item.sum*100;
            }
        }
        
        return {
            slotRtp: (countSlot / (value.length - live.length)).toFixed(),
            liveRtp: (countLive / live.length).toFixed()
        }
    }

    const {slotRtp, liveRtp} = getRtpGroup(list);

    return (
        <div className={classes.root}>
            <Title label="Отчет по провайдерам" />
            <div className={classes.wrapRtp}>
                <RTP label="SLOT RTP" percent={slotRtp}/>
                <RTP label="LIVE RTP" percent={liveRtp} />
            </div>
            <div className={classes.wrapList}>
                {
                    list.map((item) => <ProviderItem item={item} />)
                }
            </div>
        </div>
    )
}

export default Report;